var _a;
import React, { useContext, useRef, useEffect } from 'react';
import { GameDataContext } from '../providers/GameDataProvider';
import { CommunityDragonContext } from '../providers/CommunityDragonProvider';
import './Minimap.css';
import { BuffName, DragonType, JungleCampName, StructureType, Team, WardType } from '../types/snapshot/Enums';
import { MapTerrain } from '../types/all-game-data/Enums';
import MinimapDefault from '../icons/minimap_default.png';
import MinimapCloud from '../icons/minimap_cloud.png';
import MinimapMountain from '../icons/minimap_mountain.png';
import MinimapOcean from '../icons/minimap_ocean.png';
import MinimapHextech from '../icons/minimap_hextech.png';
import MinimapBorder from '../icons/minimap_border.png';
import BlueTurret from '../icons/blue_turret.png';
import BlueInhib from '../icons/blue_inhib.png';
import RedTurret from '../icons/red_turret.png';
import RedInhib from '../icons/red_inhib.png';
import BlueNexus from '../icons/blue_nexus.png';
import RedNexus from '../icons/red_nexus.png';
import BlueWard from '../icons/blue_ward.png';
import RedWard from '../icons/red_ward.png';
import BlueControlWard from '../icons/blue_control_ward.png';
import RedControlWard from '../icons/red_control_ward.png';
import JungleCampLive from '../icons/jungle_camp_live.png';
import JungleBuffLive from '../icons/jungle_buff_live.png';
import JungleRespawnLong from '../icons/jungle_respawn_long.png';
import JungleRespawnShort from '../icons/jungle_respawn_short.png';
import Baron from '../icons/baron.png';
import Herald from '../icons/herald.png';
import Horde from '../icons/horde.png';
import DragonElder from '../icons/dragon_elder.png';
import DragonCloud from '../icons/dragon_cloud.png';
import DragonMountain from '../icons/dragon_mountain.png';
import DragonInfernal from '../icons/dragon_infernal.png';
import DragonOcean from '../icons/dragon_ocean.png';
import DragonHextech from '../icons/dragon_hextech.png';
import DragonChemtech from '../icons/dragon_chemtech.png';
import BlueChampionDead from '../icons/blue_champion_dead.png';
import RedChampionDead from '../icons/red_champion_dead.png';
import MinimapRecallBlue from '../icons/minimap_recall_blue.png';
import MinimapRecallRed from '../icons/minimap_recall_red.png';
import MinimapTeleportGreen from '../icons/minimap_teleport_green.png';
import MinimapTeleportRed from '../icons/minimap_teleport_red.png';
var minimapDimensions = { width: 500, height: 500 };
var worldDimensions = { width: 14870, height: 14980 };
var blueNexus = { x: 1650, z: 1650 };
var redNexus = { x: 13220, z: 13220 };
var jungleCampSpawns = (_a = {},
    _a[JungleCampName.BLUE_GROMP] = { x: 2210, z: 8550, buff: false },
    _a[JungleCampName.BLUE_BLUE] = { x: 3800, z: 8000, buff: true },
    _a[JungleCampName.BLUE_WOLVES] = { x: 3780, z: 6520, buff: false },
    _a[JungleCampName.BLUE_RAPTORS] = { x: 7075, z: 5350, buff: false },
    _a[JungleCampName.BLUE_RED] = { x: 7765, z: 4000, buff: true },
    _a[JungleCampName.BLUE_KRUGS] = { x: 8425, z: 2650, buff: false },
    _a[JungleCampName.RED_GROMP] = { x: 12703, z: 6443, buff: false },
    _a[JungleCampName.RED_BLUE] = { x: 11050, z: 6990, buff: true },
    _a[JungleCampName.RED_WOLVES] = { x: 11100, z: 8450, buff: false },
    _a[JungleCampName.RED_RAPTORS] = { x: 7875, z: 9650, buff: false },
    _a[JungleCampName.RED_RED] = { x: 7101, z: 11000, buff: true },
    _a[JungleCampName.RED_KRUGS] = { x: 6485, z: 12375, buff: false },
    _a[JungleCampName.TOP_SCUTTLE] = { x: 4400, z: 9600, buff: false },
    _a[JungleCampName.BOT_SCUTTLE] = { x: 10500, z: 5170, buff: false },
    _a[JungleCampName.DRAGON] = { x: 9975, z: 4425, buff: true }, // buff true for sizing purposes
    _a["baron pit"] = { x: 4925, z: 10535, buff: true },
    _a);
var Minimap = function (_a) {
    var i = _a.i;
    var gameData = useContext(GameDataContext);
    var championSummary = useContext(CommunityDragonContext).championSummary;
    var canvasRef = useRef(null);
    var worldToMinimap = function (x, z) {
        var minimapX = (x / worldDimensions.width) * minimapDimensions.width;
        var minimapZ = (z / worldDimensions.height) * minimapDimensions.height;
        return [minimapX, minimapZ];
    };
    var _b = worldToMinimap(blueNexus.x, blueNexus.z), blueNexusMinimapX = _b[0], blueNexusMinimapZ = _b[1];
    var _c = worldToMinimap(redNexus.x, redNexus.z), redNexusMinimapX = _c[0], redNexusMinimapZ = _c[1];
    var minimapImage;
    switch (gameData.snapshots[i].mapTerrain) {
        case MapTerrain.CLOUD:
            minimapImage = MinimapCloud;
            break;
        case MapTerrain.MOUNTAIN:
            minimapImage = MinimapMountain;
            break;
        case MapTerrain.OCEAN:
            minimapImage = MinimapOcean;
            break;
        case MapTerrain.HEXTECH:
            minimapImage = MinimapHextech;
            break;
        default:
            minimapImage = MinimapDefault;
            break;
    }
    useEffect(function () {
        var canvas = canvasRef.current;
        var ctx = canvas.getContext('2d');
        var maskCanvas = document.createElement('canvas');
        maskCanvas.width = minimapDimensions.width;
        maskCanvas.height = minimapDimensions.height;
        var maskCtx = maskCanvas.getContext('2d');
        ctx.clearRect(0, 0, minimapDimensions.width, minimapDimensions.height);
        maskCtx.clearRect(0, 0, minimapDimensions.width, minimapDimensions.height);
        maskCtx.fillStyle = 'white';
        var visionPolygons = gameData.playerTeam === Team.BLUE ? gameData.snapshots[i].blueVisionPolygons : gameData.snapshots[i].redVisionPolygons;
        visionPolygons.forEach(function (polygon) {
            maskCtx.beginPath();
            polygon.forEach(function (point, index) {
                var x = point[0], y = point[1];
                var _a = worldToMinimap(x, y), minimapX = _a[0], minimapZ = _a[1];
                if (index === 0) {
                    maskCtx.moveTo(minimapX, minimapDimensions.height - minimapZ);
                }
                else {
                    maskCtx.lineTo(minimapX, minimapDimensions.height - minimapZ);
                }
            });
            maskCtx.closePath();
            maskCtx.fill();
        });
        ctx.fillStyle = 'rgba(0, 0, 0, 0.64)';
        ctx.fillRect(0, 0, minimapDimensions.width, minimapDimensions.height);
        ctx.globalCompositeOperation = 'destination-out';
        ctx.drawImage(maskCanvas, 0, 0);
        ctx.globalCompositeOperation = 'source-over';
    }, [gameData, i]);
    var getIconForCamp = function (campName, buff) {
        var _a;
        if (campName === 'baron pit') {
            if (gameData.snapshots[i].time <= 60 * 14) {
                var lastKilled = 0;
                for (var j = i; j >= 1; j--) {
                    if (!gameData.snapshots[j].jungle.some(function (jungle) { return jungle.name === JungleCampName.GRUB_1 || jungle.name === JungleCampName.GRUB_2 || jungle.name === JungleCampName.GRUB_3; }) && gameData.snapshots[j - 1].jungle.some(function (jungle) { return jungle.name === JungleCampName.GRUB_1 || jungle.name === JungleCampName.GRUB_2 || jungle.name === JungleCampName.GRUB_3; })) {
                        lastKilled = gameData.snapshots[j - 1].time;
                        break;
                    }
                }
                var spawnTime = lastKilled === 0 ? 60 * 6 : lastKilled < 60 * 9 + 45 ? lastKilled + 60 * 4 : Infinity;
                var timeUntilSpawn = spawnTime - gameData.snapshots[i].time;
                if (timeUntilSpawn <= 0) {
                    return Horde;
                }
                else if (timeUntilSpawn <= 10) {
                    return JungleRespawnShort;
                }
                else if (timeUntilSpawn <= 60) {
                    return JungleRespawnLong;
                }
                return null;
            }
            else if (gameData.snapshots[i].time <= 60 * 20) {
                if (gameData.snapshots[i].jungle.find(function (jungle) { return jungle.name === JungleCampName.RIFT_HERALD; })) {
                    return Herald;
                }
                else if (gameData.snapshots[i].time >= 60 * 19 + 50) { // for baron
                    return JungleRespawnShort;
                }
                else if (gameData.snapshots[i].time >= 60 * 19) {
                    return JungleRespawnLong;
                }
                return null;
            }
            else {
                var lastKilled = 0;
                for (var j = i; j >= 1; j--) {
                    if (!gameData.snapshots[j].jungle.find(function (jungle) { return jungle.name === JungleCampName.BARON; }) && gameData.snapshots[j - 1].jungle.find(function (jungle) { return jungle.name === JungleCampName.BARON; })) {
                        lastKilled = gameData.snapshots[j - 1].time;
                        break;
                    }
                }
                var spawnTime = lastKilled === 0 ? 60 * 20 : lastKilled + 60 * 6;
                var timeUntilSpawn = spawnTime - gameData.snapshots[i].time;
                if (timeUntilSpawn <= 0) {
                    return Baron;
                }
                else if (timeUntilSpawn <= 10) {
                    return JungleRespawnShort;
                }
                else if (timeUntilSpawn <= 60) {
                    return JungleRespawnLong;
                }
                return null;
            }
        }
        else if (campName === JungleCampName.DRAGON) {
            var lastKilled = 0;
            for (var j = i; j >= 1; j--) {
                if (!gameData.snapshots[j].jungle.find(function (jungle) { return jungle.name === campName; }) && gameData.snapshots[j - 1].jungle.find(function (jungle) { return jungle.name === campName; })) {
                    lastKilled = gameData.snapshots[j - 1].time;
                    break;
                }
            }
            var elderIsNext = gameData.events.filter(function (event) { return event.time <= gameData.snapshots[i].time && event.victimName.endsWith('dragon') && event.participantTeam === Team.BLUE; }).length >= 4 || gameData.events.filter(function (event) { return event.time <= gameData.snapshots[i].time && event.victimName.endsWith('dragon') && event.participantTeam === Team.RED; }).length >= 4;
            var spawnTime = lastKilled === 0 ? 60 * 5 : (elderIsNext ? lastKilled + 60 * 6 : lastKilled + 60 * 5);
            var timeUntilSpawn = spawnTime - gameData.snapshots[i].time;
            if (timeUntilSpawn <= 0) {
                var dragonType = (_a = gameData.snapshots[i].jungle.find(function (jungle) { return jungle.name === campName; })) === null || _a === void 0 ? void 0 : _a.dragonType;
                switch (dragonType) {
                    case DragonType.CLOUD:
                        return DragonCloud;
                    case DragonType.MOUNTAIN:
                        return DragonMountain;
                    case DragonType.INFERNAL:
                        return DragonInfernal;
                    case DragonType.OCEAN:
                        return DragonOcean;
                    case DragonType.CHEMTECH:
                        return DragonChemtech;
                    case DragonType.HEXTECH:
                        return DragonHextech;
                    case DragonType.ELDER:
                        return DragonElder;
                    default:
                        return null;
                }
            }
            else if (timeUntilSpawn <= 10) {
                return JungleRespawnShort;
            }
            else if (timeUntilSpawn <= 60) {
                return JungleRespawnLong;
            }
            return null;
        }
        else if (campName === JungleCampName.TOP_SCUTTLE || campName === JungleCampName.BOT_SCUTTLE) {
            var spawnTime = Infinity;
            for (var j = i; j < gameData.snapshots.length; j++) { // look ahead, because they don't spawn predictably
                if (gameData.snapshots[j].jungle.find(function (jungle) { return jungle.name === campName; })) {
                    spawnTime = gameData.snapshots[j].time;
                    break;
                }
            }
            var timeUntilSpawn = spawnTime - gameData.snapshots[i].time;
            if (timeUntilSpawn <= 0) {
                return JungleCampLive;
            }
            else if (timeUntilSpawn <= 10) {
                return JungleRespawnShort;
            }
            else if (timeUntilSpawn <= 60) {
                return JungleRespawnLong;
            }
            return null;
        }
        else {
            var lastKilled = 0;
            for (var j = i; j >= 1; j--) {
                if (!gameData.snapshots[j].jungle.find(function (jungle) { return jungle.name === campName; }) && gameData.snapshots[j - 1].jungle.find(function (jungle) { return jungle.name === campName; })) {
                    lastKilled = gameData.snapshots[j - 1].time;
                    break;
                }
            }
            var lateSpawn = campName === JungleCampName.BLUE_GROMP || campName === JungleCampName.RED_GROMP || campName === JungleCampName.BLUE_KRUGS || campName === JungleCampName.RED_KRUGS;
            var spawnTime = lastKilled === 0 ? (lateSpawn ? 60 * 1 + 42 : 60 * 1 + 30) : lastKilled + (buff ? 60 * 5 : 60 * 2 + 15);
            var timeUntilSpawn = spawnTime - gameData.snapshots[i].time;
            if (timeUntilSpawn <= 0) {
                return buff ? JungleBuffLive : JungleCampLive;
            }
            else if (timeUntilSpawn <= 10) {
                return JungleRespawnShort;
            }
            else if (timeUntilSpawn <= 60) {
                return buff ? JungleRespawnLong : null;
            }
            else {
                return null;
            }
        }
    };
    return (React.createElement("div", { style: { position: 'relative', minWidth: minimapDimensions.width, height: minimapDimensions.height } },
        React.createElement("img", { src: MinimapBorder, style: { width: '108%', height: '108%', zIndex: 2000, position: 'absolute', left: '-4%', bottom: '-4%' }, draggable: false }),
        React.createElement("img", { src: minimapImage, style: { width: '100%', height: '100%', zIndex: 0, position: 'absolute', left: 0, bottom: 0 }, draggable: false }),
        React.createElement("div", { style: { width: '100%', height: '100%', overflow: 'hidden', contain: 'content' } },
            React.createElement("canvas", { ref: canvasRef, width: minimapDimensions.width, height: minimapDimensions.height, style: { position: 'absolute', left: 0, bottom: 0, zIndex: 100 } }),
            gameData.snapshots[i].minions.map(function (minion, j) {
                if (!minion.visible) {
                    return null;
                }
                var _a = worldToMinimap(minion.x, minion.z), minimapX = _a[0], minimapZ = _a[1];
                var bgColor = minion.team === Team.BLUE ? 'rgba(0, 163, 240)' : 'rgba(230, 10, 20)';
                return (React.createElement("div", { key: j, style: { position: 'absolute', left: minimapX, bottom: minimapZ, transform: 'translate(-50%, 50%)', width: 8, height: 8, backgroundColor: bgColor, borderRadius: '50%', border: '1px solid black', zIndex: 1 } }));
            }),
            gameData.snapshots[i].champions.map(function (champion, j) {
                var _a;
                if (!champion.visible && champion.alive) {
                    return null;
                }
                var _b = worldToMinimap(champion.x, champion.z), minimapX = _b[0], minimapZ = _b[1];
                if (champion.alive) {
                    var id = (_a = championSummary.find(function (championSummary) { return championSummary.alias.toLowerCase() === champion.name; })) === null || _a === void 0 ? void 0 : _a.id;
                    var src = "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/champion-icons/".concat(id, ".png");
                    var borderColor = champion.team === Team.BLUE ? 'rgba(0, 163, 240)' : 'rgba(230, 10, 20)';
                    var isPlayerChampion = champion.team === gameData.playerTeam && champion.name === gameData.playerChampion;
                    return (React.createElement("div", { key: j, style: { position: 'absolute', left: minimapX, bottom: minimapZ, transform: 'translate(-50%, 50%)', width: 45, height: 45, zIndex: isPlayerChampion ? 1000 : 103 } },
                        React.createElement("div", { style: { position: 'relative', width: '100%', height: '100%' } },
                            React.createElement("img", { src: src, alt: champion.name, style: { position: 'absolute', left: 0, top: 0, width: '100%', height: '100%', borderRadius: '50%', border: "2px solid ".concat(borderColor) } }),
                            champion.buffs.find(function (buff) { return buff.name === BuffName.RECALL; }) &&
                                React.createElement("div", { style: { position: 'absolute', left: '50%', top: '50%', width: '150%', height: '150%', transform: 'translate(-50%, -50%)' } },
                                    React.createElement("img", { src: champion.team === Team.BLUE ? MinimapRecallBlue : MinimapRecallRed, style: { width: '100%', height: '100%', animation: 'rotate 4s linear infinite' } })),
                            champion.buffs.find(function (buff) { return buff.name === BuffName.EMPOWERED_RECALL; }) &&
                                React.createElement("div", { style: { position: 'absolute', left: '50%', top: '50%', width: '150%', height: '150%', transform: 'translate(-50%, -50%)' } },
                                    React.createElement("img", { src: champion.team === Team.BLUE ? MinimapRecallBlue : MinimapRecallRed, style: { width: '100%', height: '100%', animation: 'rotate 2s linear infinite' } })),
                            champion.buffs.find(function (buff) { return buff.name === BuffName.TELEPORT; }) &&
                                React.createElement("div", { style: { position: 'absolute', left: '50%', top: '50%', width: '170%', height: '170%', transform: 'translate(-50%, -50%)' } },
                                    React.createElement("img", { src: champion.team === Team.BLUE ? MinimapTeleportGreen : MinimapTeleportRed, style: { width: '100%', height: '100%', animation: 'rotate 2s linear infinite' } })))));
                }
                else {
                    return (React.createElement("img", { key: j, src: champion.team === Team.BLUE ? BlueChampionDead : RedChampionDead, style: { position: 'absolute', left: minimapX, bottom: minimapZ, transform: 'translate(-50%, 50%)', width: 45, height: 45, zIndex: 103 } }));
                }
            }),
            gameData.snapshots[i].structures.map(function (structure, j) {
                var _a = worldToMinimap(structure.x, structure.z), minimapX = _a[0], minimapZ = _a[1];
                var src = structure.team === Team.BLUE ? structure.type === StructureType.TURRET ? BlueTurret : BlueInhib : structure.type === StructureType.TURRET ? RedTurret : RedInhib;
                var dim = structure.type === StructureType.TURRET ? 35 : 30;
                return (React.createElement("img", { key: j, src: src, style: { position: 'absolute', left: minimapX, bottom: minimapZ, transform: 'translate(-50%, 50%)', width: dim, height: dim, zIndex: 101 } }));
            }),
            React.createElement("img", { src: BlueNexus, style: { position: 'absolute', left: blueNexusMinimapX, bottom: blueNexusMinimapZ, transform: 'translate(-50%, 50%)', width: 38, height: 38, zIndex: 101 } }),
            React.createElement("img", { src: RedNexus, style: { position: 'absolute', left: redNexusMinimapX, bottom: redNexusMinimapZ, transform: 'translate(-50%, 50%)', width: 38, height: 38, zIndex: 101 } }),
            gameData.snapshots[i].wards.map(function (ward, j) {
                var _a = worldToMinimap(ward.x, ward.z), minimapX = _a[0], minimapZ = _a[1];
                var src = ward.team === Team.BLUE ? ward.type === WardType.CONTROL ? BlueControlWard : BlueWard : ward.type === WardType.CONTROL ? RedControlWard : RedWard;
                return (React.createElement("img", { key: j, src: src, style: { position: 'absolute', left: minimapX, bottom: minimapZ, transform: 'translate(-50%, 50%)', width: 30, height: 30, zIndex: 102 } }));
            }),
            Object.entries(jungleCampSpawns).map(function (_a, j) {
                var campName = _a[0], campData = _a[1];
                var x = campData.x, z = campData.z, buff = campData.buff;
                var _b = worldToMinimap(x, z), minimapX = _b[0], minimapZ = _b[1];
                var src = getIconForCamp(campName, buff);
                if (!src) {
                    return null;
                }
                var width, height;
                if (src === JungleCampLive) {
                    width = 30;
                    height = 20;
                }
                else if (src === JungleBuffLive) {
                    width = 50;
                    height = 50;
                }
                else if (src === JungleRespawnLong || src === JungleRespawnShort) {
                    if (buff) {
                        width = 25;
                        height = 25;
                    }
                    else {
                        width = 20;
                        height = 20;
                    }
                }
                else {
                    width = 30;
                    height = 30;
                }
                return (React.createElement("img", { key: j, src: src, style: { position: 'absolute', left: minimapX, bottom: minimapZ, transform: 'translate(-50%, 50%)', width: width, height: height, zIndex: 101 } }));
            }),
            gameData.snapshots[i].minions.concat(gameData.snapshots[i].wards).concat(gameData.snapshots[i].structures).map(function (snapshotObject, j) {
                if (snapshotObject.buffs.find(function (buff) { return buff.name === BuffName.TELEPORT_TARGET; })) {
                    var _a = worldToMinimap(snapshotObject.x, snapshotObject.z), minimapX = _a[0], minimapZ = _a[1];
                    return (React.createElement("div", { key: j, style: { position: 'absolute', left: minimapX, bottom: minimapZ, width: 60, height: 60, transform: 'translate(-50%, 50%)', zIndex: 103 } },
                        React.createElement("img", { src: snapshotObject.team === Team.BLUE ? MinimapTeleportGreen : MinimapTeleportRed, style: { width: '100%', height: '100%', animation: 'rotate 2s linear infinite' } })));
                }
            }))));
};
export default Minimap;
